import { Provider as OraclePackageWrapper } from "@dpdgroupuk/ai-app";
import { Route } from "react-router";

import { HOME } from "../constants/routes";
import { Mapper } from "../pages/Mapper";
import { Header } from "../components/Header";
import { Sidebar } from "../components/Sidebar";

import api from "../utils/api";

const { REACT_APP_ORACLE_API_URL, REACT_APP_ORACLE_WEB_URL } = process.env;

const pageTitleMapper = [
  {
    routeName: HOME,
    pageTitle: "Volume Simulation (Quantum)",
  },
];

export const OracleRoutes = () => {
  return (
    <OraclePackageWrapper
      axiosInstance={api}
      mainProjectUrl={REACT_APP_ORACLE_WEB_URL}
      mainProjectApiUrl={REACT_APP_ORACLE_API_URL}
      pageTitleMapper={pageTitleMapper}
    >
      <Route
        path={HOME}
        element={
          <Header>
            <Sidebar />
            <Mapper />
          </Header>
        }
      />
    </OraclePackageWrapper>
  );
};
